/**
 * Miniatura de mídia no carrossel de anexo (seleção + remoção).
 * Mobile-first; remoção alinhada ao design system.
 */
import React from 'react';
import { AppIcon } from '../../../../components/icons/AppIcon';
import { cn } from '@/lib/utils';

interface ChatMediaThumbProps {
    previewUrl: string;
    file: File;
    isActive?: boolean;
    onSelect?: () => void;
    onRemove: () => void;
}

export const ChatMediaThumb: React.FC<ChatMediaThumbProps> = ({
    previewUrl,
    file,
    isActive = false,
    onSelect,
    onRemove,
}) => {
    const isVideo = file.type.startsWith('video/');

    return (
        <article
            className={cn(
                'group relative size-14 shrink-0 overflow-hidden rounded-lg border sm:size-16 sm:rounded-xl',
                isActive ? 'border-primary' : 'border-subtle'
            )}
            aria-current={isActive ? 'true' : undefined}
        >
            <button
                type="button"
                onClick={onSelect}
                className="relative size-full focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary/20"
                aria-pressed={isActive}
                aria-label={
                    isVideo ? `Selecionar vídeo ${file.name}` : `Selecionar imagem ${file.name}`
                }
            >
                <img src={previewUrl} alt="" className="size-full object-cover" />
                {isVideo && (
                    <span
                        className="absolute inset-0 flex items-center justify-center bg-foreground/40"
                        aria-hidden="true"
                    >
                        <AppIcon name="play" className="size-4 text-background sm:size-5" />
                    </span>
                )}
            </button>
            <button
                type="button"
                onClick={(e) => {
                    e.stopPropagation();
                    onRemove();
                }}
                className={cn(
                    'absolute right-0.5 top-0.5 flex size-6 items-center justify-center rounded-md',
                    'bg-card/90 text-muted backdrop-blur-sm',
                    'transition-colors hover:bg-surface-subtle hover:text-destructive',
                    'focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary/20',
                    'sm:opacity-0 sm:group-hover:opacity-100 sm:group-focus-within:opacity-100'
                )}
                aria-label={`Remover ${file.name}`}
            >
                <AppIcon name="x" className="size-3.5" aria-hidden />
            </button>
        </article>
    );
};
